import React, { ReactElement } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { IRadioButtonProps } from './types/RadioButton';

const Input = styled('input')`
  display: none;
  cursor: pointer;
  &:checked + label::before {
    border: 7px solid #2490de;
  }
`;

const Label = styled('label')`
  display: flex;
  align-items: center;
  cursor: pointer;
  &::before {
    content: '';
    display: inline-block;
    box-sizing: border-box;
    width: 22px;
    height: 22px;
    background-color: #ffffff;
    border: 2px solid #2490de;
    border-radius: 50%;
    margin-right: 8px;
  }
  &::before + input:checked {
    border: 7px solid #2490de;
  }
`;

const updateToBold = (label: string, id: string, isChecked: boolean | undefined) => {
  if (id === 'radio-new-card' && isChecked) {
    return <strong>{`${label}`}</strong>;
  }

  if (id === 'radio-card-reference') {
    const words = label.split(' ');

    return words.map(str => {
      return str === 'Visa' ||
        str === 'Mastercard' ||
        str === 'Amex' ||
        str === 'Discover' ||
        (parseInt(str) && typeof parseInt(str) === 'number') ? (
        <strong key={Math.floor(Math.random() * 999)}>{` ${str}`}</strong>
      ) : (
        ` ${str}`
      );
    });
  }

  return label;
};

const RadioButton = ({
  id,
  name,
  label,
  style,
  onRadioChange,
  value,
  checked,
  labelId = '',
}: IRadioButtonProps): ReactElement => {
  return (
    <div style={style}>
      <Input
        type="radio"
        data-test-id={`radio-${name}-${value}`}
        name={name}
        id={id}
        onChange={onRadioChange}
        // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
        value={value}
        checked={checked}
      />
      <Label htmlFor={`${id}`} data-test-id={labelId}>
        <span>{updateToBold(label, labelId, checked)}</span>
      </Label>
    </div>
  );
};

RadioButton.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onRadioChange: PropTypes.func.isRequired,
  value: PropTypes.any,
  checked: PropTypes.bool,
};

export default RadioButton;
